export const SERVICE_TIME_ZONE = 'Asia/Seoul';

function normalizedDate(value: any): Date | null {
    if (value instanceof Date) {
        return isNaN(value.getTime()) ? null : value;
    }
    if (typeof value === 'number') {
        let result = new Date(value);
        return isNaN(result.getTime()) ? null : result;
    }
    let text = String(value || '').trim();
    if (!text) return null;
    if (/^\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?$/.test(text)) {
        text = text.includes('T') ? text : text.replace(' ', 'T');
        if (text.length === 10) text += 'T00:00:00';
        text += 'Z';
    }
    let result = new Date(text);
    return isNaN(result.getTime()) ? null : result;
}

function kstParts(value: Date) {
    let parts: any = {};
    new Intl.DateTimeFormat('en-CA', {
        timeZone: SERVICE_TIME_ZONE,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hourCycle: 'h23'
    }).formatToParts(value).forEach((part: any) => {
        if (part.type !== 'literal') parts[part.type] = part.value;
    });
    return parts;
}

export function formatKstDateTime(value: any, fallback: string = '—') {
    let date = normalizedDate(value);
    if (!date) return value ? String(value) : fallback;
    return new Intl.DateTimeFormat('ko-KR', {
        timeZone: SERVICE_TIME_ZONE,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).format(date);
}

export function formatKstDate(value: any, fallback: string = '—') {
    let date = normalizedDate(value);
    if (!date) return value ? String(value) : fallback;
    return new Intl.DateTimeFormat('ko-KR', {
        timeZone: SERVICE_TIME_ZONE,
        year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(date);
}

export function currentKstInputDateTime() {
    let part = kstParts(new Date());
    return `${part.year}-${part.month}-${part.day}T${part.hour}:${part.minute}`;
}

export function currentKstDateCompact() {
    let part = kstParts(new Date());
    return `${part.year}${part.month}${part.day}`;
}

export function serviceTimestamp(value: any) {
    let date = normalizedDate(value);
    return date ? date.getTime() : NaN;
}

export function kstDateStartTimestamp(value: string) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value || ''))) return NaN;
    return new Date(`${value}T00:00:00+09:00`).getTime();
}
